import type { DisruptionPnrGroupRow } from '@/lib/disruptions/types';
import type { ReservationStatus } from '@/lib/booking/types';

/**
 * Where a ride for this PNR would go — and so whether ground transport can be
 * organised at all. A transfer needs a DEFINED destination:
 *
 *   - `HOTEL` — a CONFIRMED room. A HELD room is still an offer: the passenger
 *     may decline it or the hold may be released, and a car sent to it would
 *     drive to a hotel nobody stays at.
 *   - `HOME`  — the declared stay-home (operator or the passenger's own
 *     "prefiero ir a mi domicilio" — both land as `LOCAL_RESIDENT`).
 *   - `null`  — nothing to drive to yet: the transport surface offers no
 *     dispatch, voucher or estimate until one of the two exists.
 *
 * The live reservation (booking read) wins over the roster denorm, which is
 * snapshot-stale right after a hold or a confirmation. An absent denorm status
 * is a legacy BOOKED row.
 */
export type TransportDestination = 'HOTEL' | 'HOME' | null;

export function transportDestination(
  group: Pick<DisruptionPnrGroupRow, 'passengerElection' | 'hotelReservationUrn' | 'hotelReservationStatus'>,
  reservation: { status: ReservationStatus } | null | undefined,
): TransportDestination {
  const hotelConfirmed = reservation
    ? reservation.status === 'BOOKED'
    : !!group.hotelReservationUrn && group.hotelReservationStatus !== 'HELD';
  if (hotelConfirmed) return 'HOTEL';
  if (group.passengerElection === 'LOCAL_RESIDENT') return 'HOME';
  return null;
}

